export const CLIENT_EXPERIENCE_MANAGER_REVIEW_DATA = [
    {
        id: 1,
        title: "Leadership & Accountability",
        definition: "Owns the client experience and design execution outcomes, not just tasks.",
        questions: [
            "Acts as the clear owner of the client experience from selections through handoff.",
            "Intervenes early when client confusion or drift appears.",
            "Sets and maintains professional standards in all client and internal interactions.",
            "Escalates issues early before they affect schedule or budget.",
            "Takes ownership of mistakes and implements prevention steps.",
            "Leads calmly under pressure and client emotion.",
            "Protects LIDA’s reputation in every interaction.",
            "Holds themselves accountable to deadlines without reminders.",
            "Is trusted by PMs, clients, and trades.",
            "Acts as the single point of accountability for selections and documentation outcomes."
        ]
    },
    {
        id: 2,
        title: "Planning & Schedule Management",
        definition: "Drives selections and documentation to match the construction schedule.",
        questions: [
            "Maintains current selections timelines aligned with build milestones.",
            "Prevents selections from going past required deadlines.",
            "Plans weeks ahead rather than reacting to urgency.",
            "Coordinates decisions with the PM schedule.",
            "Drives long-lead selections early.",
            "Builds recovery plans when timelines slip.",
            "Rarely surprises the PM or client with late decisions.",
            "Keeps milestones visible and managed.",
            "Sequences selections logically to prevent overwhelm.",
            "Delivers decisions in line with schedule commitments."
        ]
    },
    {
        id: 3,
        title: "Financial Management & Budget Control",
        definition: "Understands how decisions affect budget, allowances, and margin.",
        questions: [
            "Creates clarity around allowances before selections are finalized.",
            "Guides clients to make value-aligned decisions within budget.",
            "Prevents costly rework caused by unclear selections.",
            "Understands the financial impact of late decisions and revisions.",
            "Communicates financial risks early to PM and client.",
            "Does not create avoidable costs through documentation errors.",
            "Balances client desires with project realities when advising selections.",
            "Owns mistakes quickly when financial impact occurs.",
            "Prevents margin erosion by ensuring selections are clear, complete, and buildable.",
            "Protects LIDA’s profitability through disciplined execution."
        ]
    },
    {
        id: 4,
        title: "Quality Control & Standards",
        definition: "Produces high-quality, buildable documentation and specifications.",
        questions: [
            "Maintains clean, current specs and removes outdated versions.",
            "Ensures drawings and measurements are correct before release.",
            "Creates documentation trades can execute without confusion.",
            "Maintains strong version control so the team knows what is current.",
            "Produces organized, easy-to-use spec packages.",
            "Prevents documentation-driven RFIs by catching gaps before they hit site.",
            "Maintains a high standard of detail and accuracy under pressure.",
            "Protects long-term durability and performance through clear specs.",
            "Treats documentation quality as a core craft standard—not a paperwork requirement.",
            "Is known for accurate, reliable documentation and packages."
        ]
    },
    {
        id: 5,
        title: "Client / Stakeholder Experience & Communication",
        definition: "Creates calm, trust, clarity, and WOW experience for clients and stakeholders.",
        questions: [
            "Delivers consistent weekly client updates by the agreed deadline (where applicable).",
            "Responds to active client messages within 24 hours and does not let communication sit.",
            "Sets clear expectations with clients and prevents surprises through proactive communication.",
            "Communicates difficult information early, clearly, and professionally (no avoidance).",
            "Maintains a calm, confident tone that reduces client anxiety and builds trust.",
            "Protects the client relationship during stressful moments and prevents escalation.",
            "Runs organized, outcome-focused client conversations that end with clarity and next steps.",
            "Confirms stakeholders (client/PM/site) understand what was decided and what happens next.",
            "Drives client satisfaction (WOW experience) at or above standard.",
            "Creates a consistent “LIDA experience” that clients would enthusiastically recommend."
        ]
    },
    {
        id: 6,
        title: "Systems & Administrative Discipline",
        definition: "Runs work through Buildertrend, scorecards, and repeatable systems—not memory.",
        questions: [
            "Maintains Buildertrend hygiene: tasks, selections, docs, and notes are current and in the right place.",
            "Completes required scorecard/admin tasks on time every week.",
            "Uses checklists and repeatable processes rather than relying on memory.",
            "Ensures selections are documented in the correct location and format every time.",
            "Prevents avoidable handoff failures by confirming the PM/site has what they need before it becomes urgent.",
            "Keeps internal commitments and deadlines without needing reminders or escalation.",
            "Ensures POs / procurement documentation (where applicable) is saved and released correctly to prevent issues.",
            "Keeps project data auditable, reliable, and easy to find.",
            "Improves workflows and suggests system improvements instead of working around the process.",
            "Demonstrates reliable weekly execution as reflected in performance/scorecard trends."
        ]
    },
    {
        id: 7,
        title: "Risk Management & Problem Prevention",
        definition: "Prevents rework and disputes through clarity, documentation, and early escalation.",
        questions: [
            "Operates with a prevention mindset: catches issues early before they become expensive or emotional.",
            "Prevents verbal/unclear selections from reaching site without confirmation and documentation.",
            "Escalates risks early when the cost of delay or error is rising.",
            "Prevents rework by ensuring decisions and documentation are correct before site execution.",
            "Protects the client by documenting decisions in a way that prevents disputes later.",
            "Protects the builder by ensuring documentation is auditable and defensible.",
            "Prevents repeated documentation mistakes by implementing a prevention step after errors.",
            "Ensures the PM/site is never surprised by late decisions or missing information.",
            "Maintains professional diligence when workload is high (no quality drop).",
            "Protects LIDA’s reputation and profitability through disciplined execution."
        ]
    },
    {
        id: 8,
        title: "Resource & Team Coordination",
        definition: "Integrates design, client decisions, and production realities to prevent friction.",
        questions: [
            "Maintains strong working relationships with PMs built on clarity, reliability, and trust.",
            "Proactively communicates what the PM/site needs next—before they have to ask.",
            "Coordinates with site and trades so selections and documentation match real field conditions.",
            "Creates clean internal handoffs that reduce friction and rework.",
            "Resolves cross-team issues quickly and professionally without blame or drama.",
            "Communicates constraints and tradeoffs clearly (time, cost, feasibility).",
            "Acts as an integrator: aligns client, design, and production realities.",
            "Leads meetings and conversations that produce decisions and alignment.",
            "Builds credibility so the field team trusts the information and follows it.",
            "Supports predictable throughput so PMs can plan confidently."
        ]
    },
    {
        id: 9,
        title: "Continuous Improvement & Professional Development",
        definition: "Improves craft, systems, and leadership maturity every year.",
        questions: [
            "Is coachable and open to feedback without defensiveness.",
            "Actively works on self-improvement in client leadership and design execution.",
            "Seeks training and professional development to raise technical and communication skill.",
            "Shares lessons learned with the team to prevent repeat errors.",
            "Improves systems instead of working around them.",
            "Supports and develops others through collaboration and clarity.",
            "Contributes positively to culture and team morale.",
            "Represents LIDA professionally at all times.",
            "Raises standards beyond their own workload.",
            "Leaves the organization stronger than they found it."
        ]
    },
    {
        id: 10,
        title: "Alignment with LIDA Core Values & Culture",
        definition: "Lives LIDA values and protects the LIDA standard in daily behavior.",
        questions: [
            "Lives LIDA core values consistently in day-to-day behavior.",
            "Acts in a way that creates a WOW experience for clients and team.",
            "Does what they say they are going to do—internally and externally.",
            "Maintains a professional, calm, and respectful presence in all interactions.",
            "Takes ownership when things go wrong and leads solutions.",
            "Treats clients, PMs, site, and trades with respect at all times.",
            "Contributes to a positive, accountable team environment.",
            "Is viewed as a culture carrier at LIDA.",
            "Is someone others want to work with on complex projects.",
            "Raises the bar for what “professional” means at LIDA."
        ]
    }
];
